import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const apero = defineConnector({
  identifier: "apero",
  name: "Apero",
  tagLine: "Healthcare billing and revenue cycle",
  logo,
  tags: ["productivity", "data"],
  defaultUrlPattern: () => "https://api\\.aperohealth\\.com/.*",
  protocol: "http",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Request API access",
      items: [
        {
          kind: "markdown",
          content:
            "Apero’s API is partner-gated. Sign in to the [Apero developer portal](https://developers.aperohealth.com/) or contact your Apero account team to enable API access and issue an API key for your organization.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://api.aperohealth.com/health",
      expectedStatus: 200,
      expectedBodyContains: "So long and thanks for all the fish.",
    }),
  },
});
